import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "size-full px-3 py-2 flex overflow-hidden flex-col" };
const _hoisted_2 = { class: "w-full h-10 mt-1 mb-2 flex gap-2 relative" };
const _hoisted_3 = { class: "absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-1" };
const _hoisted_4 = { class: "w-full h-10 mt-1 flex gap-2" };
const _hoisted_5 = { class: "flex-1 overflow-hidden h-full flex items-center justify-center" };
const _hoisted_6 = { class: "flex justify-between items-center mb-3 flex-none w-full h-auto" };
const _hoisted_7 = {
    key: 0,
    class: "font-semibold text-xl flex-none text-black"
};
const _hoisted_8 = {
    key: 1,
    class: "font-semibold text-xl flex-none text-black"
};
const _hoisted_9 = { class: "flex-none flex gap-4 relative" };
const _hoisted_10 = {
    key: 0,
    class: "flex gap-4 relative"
};
const _hoisted_11 = {
    key: 1,
    class: "flex gap-4 relative"
};
const _hoisted_12 = { class: "relative" };
const _hoisted_13 = {
    key: 0,
    class: "absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200"
};
const _hoisted_14 = { class: "py-1" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "flex-1 size-full overflow-y-auto" };
import { ArrowUpDown, CheckCircle, LayoutGrid, List, Share, SlidersVertical, X, Search, } from "lucide-vue-next";
import MarketTabItem from "./market-tab-item.vue";
import { useHomeStore } from "./homeStore";
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { useHomeFilterStore } from "./homeFilterStore";
import { LoadMoreIndicatorType } from "../common/common-type";
export default /*@__PURE__*/ _defineComponent({
    __name: 'market-tab',
    setup(__props) {
        const homeStore = useHomeStore();
        const homeFilterStore = useHomeFilterStore();
        const isLoading = ref(false);
        const indicatorRef = ref();
        let csrfCookieReady = false;
        const filterAlphanumeric = (event) => {
            const target = event.target;
            const value = target.value.replace(/[^a-zA-Z0-9\s&.'-]/g, '');
            homeFilterStore.keywords = value;
            target.value = value;
        };
        const clearSearch = () => {
            homeFilterStore.keywords = '';
        };
        onMounted(async () => {
            if (!csrfCookieReady) {
                csrfCookieReady = true;
                try {
                    await fetch("/sanctum/csrf-cookie", { credentials: "include" });
                }
                catch {
                    csrfCookieReady = false;
                }
            }
            document.addEventListener("click", handleClickOutside);
        });
        onUnmounted(() => {
            document.removeEventListener("click", handleClickOutside);
        });
        const showSortDropdown = ref(false);
        const updateSortBy = (value) => {
            if (homeFilterStore.sortBy === value)
                return;
            homeFilterStore.sortBy = value;
            showSortDropdown.value = false;
            // Reset the load-more indicator when changing sort so the UI shows "loading" again
            indicatorRef.value?.setStatus(LoadMoreIndicatorType.Loading);
        };
        const changeItemView = () => {
            homeStore.itemInGridView = !homeStore.itemInGridView;
        };
        const toggleSortDropdown = () => {
            showSortDropdown.value = !showSortDropdown.value;
        };
        const toggleSelectionView = () => {
            homeStore.itemInSelectionView = !homeStore.itemInSelectionView;
            if (!homeStore.itemInSelectionView) {
                homeStore.selectedItems = [];
            }
        };
        // Close dropdown when clicking outside
        const handleClickOutside = (event) => {
            const target = event.target;
            if (!target.closest(".relative")) {
                showSortDropdown.value = false;
            }
        };
        const gridClasses = computed(() => {
            return homeStore.itemInGridView
                ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
                : "grid-cols-1 lg:grid-cols-2";
        });
        const load = async () => {
            getMarketListingHandling();
        };
        // Watch for page reset (new search) and reset the load-more indicator to loading state.
        watch(() => homeFilterStore.market.pagination.current_page, (newPage, oldPage) => {
            // When page is reset to 1 (user applies filters / search again), turn on the indicator.
            if (newPage === 1 && newPage !== oldPage) {
                indicatorRef.value?.setStatus(LoadMoreIndicatorType.Loading);
            }
        });
        // Also watch for the store flag that indicates we're calling the API; reset indicator when API call starts for new search
        watch(() => homeFilterStore.isCallingApi, (isCalling) => {
            if (isCalling && homeFilterStore.market.pagination.current_page === 1) {
                indicatorRef.value?.setStatus(LoadMoreIndicatorType.Loading);
            }
        });
        const getMarketListingHandling = async () => {
            if (isLoading.value)
                return;
            isLoading.value = true;
            // Set to loading but keep observer disconnected to prevent re-trigger while API is in flight
            indicatorRef.value?.setStatus(LoadMoreIndicatorType.Loading, false);
            const market = homeFilterStore.market;
            console.log(market.pagination.has_more_pages);
            if (!market.pagination.has_more_pages) {
                // if (state) state.complete()
                indicatorRef.value?.setStatus(LoadMoreIndicatorType.Complete);
                isLoading.value = false;
                return;
            }
            if (market.list.length > 0)
                market.pagination.current_page++;
            const response = await homeFilterStore.getMarketListingApi();
            if (response === null || response.status === 0) {
                // if (state) state.noData()
                indicatorRef.value?.setStatus(LoadMoreIndicatorType.NoData);
                isLoading.value = false;
                return;
            }
            isLoading.value = false;
            // Reconnect observer after fetch so it can trigger on scroll again
            indicatorRef.value?.setStatus(LoadMoreIndicatorType.Loading, true);
        };
        return (_ctx, _cache) => {
            const _component_home_filter_dialog_selected_filter = _resolveComponent("home-filter-dialog-selected-filter");
            const _component_load_more_indicator = _resolveComponent("load-more-indicator");
            const _component_home_filter_dialog = _resolveComponent("home-filter-dialog");
            const _component_home_share_dialog = _resolveComponent("home-share-dialog");
            const _component_home_qr_dialog = _resolveComponent("home-qr-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(homeFilterStore).keywords) = $event)),
                        onInput: filterAlphanumeric,
                        type: "text",
                        placeholder: "Search keywords...",
                        class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge"
                    }, null, 544), [
                        [_vModelText, _unref(homeFilterStore).keywords]
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        (_unref(homeFilterStore).keywords)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: clearSearch,
                                class: "p-1 hover:bg-badge/10 rounded-full transition-colors",
                                title: "Clear search"
                            }, [
                                _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_unref(Search), { class: "size-4 text-badge/50" })
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(homeFilterStore).showFilterMenu = true)),
                        class: "cursor-pointer px-2 flex justify-center items-center h-full bg-black rounded-[4px] overflow-hidden text-white text-base"
                    }, [
                        _createVNode(_unref(SlidersVertical), { class: "size-6 p-1" }),
                        _createTextVNode("Filter (" + _toDisplayString(_unref(homeFilterStore).totalFilterCount) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_home_filter_dialog_selected_filter)
                    ])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full h-[1px] bg-line my-1" }, null, -1)),
                _createElementVNode("div", _hoisted_6, [
                    (_unref(homeStore).itemInSelectionView)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(homeStore).selectedItems.length) + " item(s) selected ", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(homeFilterStore).market.pagination.total) + " listings ", 1)),
                    _createElementVNode("div", _hoisted_9, [
                        (_unref(homeStore).itemInSelectionView)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_unref(Share), {
                                    class: "size-8 p-1 text-badge cursor-pointer",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (_unref(homeStore).showShareDialog = true))
                                }),
                                _createVNode(_unref(X), {
                                    class: "size-8 p-1 text-badge cursor-pointer",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (toggleSelectionView()))
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_unref(CheckCircle), {
                                    class: "size-8 p-1 text-badge cursor-pointer",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (toggleSelectionView()))
                                }),
                                (_unref(homeStore).itemInGridView)
                                    ? (_openBlock(), _createBlock(_unref(List), {
                                        key: 0,
                                        class: "size-8 p-1 text-badge cursor-pointer",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (changeItemView()))
                                    }))
                                    : (_openBlock(), _createBlock(_unref(LayoutGrid), {
                                        key: 1,
                                        class: "size-8 p-1 text-badge cursor-pointer",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (changeItemView()))
                                    })),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_unref(ArrowUpDown), {
                                        class: "size-8 p-1 text-badge cursor-pointer",
                                        onClick: toggleSortDropdown
                                    }),
                                    (showSortDropdown.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeFilterStore).SortOption, (option) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: option.value,
                                                        onClick: ($event) => (updateSortBy(option.value)),
                                                        class: _normalizeClass(["block w-full text-left px-4 py-2 text-base hover:bg-gray-100 transition-colors", {
                                                                'bg-gray-50 font-semibold': _unref(homeFilterStore).sortBy === option.value,
                                                            }])
                                                    }, _toDisplayString(option.label), 11, _hoisted_15));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                        class: _normalizeClass(['grid gap-4 h-auto w-full', gridClasses.value]),
                        id: "market-products"
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeFilterStore).market.list, (item) => {
                            return (_openBlock(), _createBlock(MarketTabItem, {
                                key: item.id,
                                data: item
                            }, null, 8, ["data"]));
                        }), 128))
                    ], 2),
                    _createVNode(_component_load_more_indicator, {
                        ref_key: "indicatorRef",
                        ref: indicatorRef,
                        onLoadMore: load
                    }, null, 512)
                ]),
                _createVNode(_component_home_filter_dialog),
                _createVNode(_component_home_share_dialog),
                _createVNode(_component_home_qr_dialog)
            ]));
        };
    }
});
